export const GA_ID = 'G-P49L305WXH'

export function gaReady() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

export function pageview(path) {
  if (!gaReady()) return
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: path
  })
}

export function track(eventName, params = {}) {
  if (!gaReady()) return
  window.gtag('event', eventName, params)
}
